/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/protocols';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "franklin": {
        "nested": {
          "BrowserInteraction": {
            "fields": {
              "timestamp": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "siftScienceToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "antibotReport": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "headerName": {
                "type": "string",
                "id": 4,
                "rule": "repeated"
              },
              "clientIp": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "trackingCookie": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "requestHeaders": {
                "type": "squareup.common.Headers",
                "id": 7,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.franklin?.nested?.BrowserInteraction) {
  $root.addJSON(jsonData);
}

/**
 * This is used as user interaction via browser, incoming email or app.
 * We should be very careful adding/removing new fields since this data is persisted by services
 * and used widely.
 *
 * SOURCE BrowserInteraction @ squareup/franklin/browser_interaction.proto at 16:1
 */
export const BrowserInteraction = $root.lookupType('squareup.franklin.BrowserInteraction');
fixType(BrowserInteraction);
Builder.createAndAttachToType(BrowserInteraction);